import { AutoPilotStatus } from '@/types';
import { api, ENDPOINTS } from '../config';
import type { AutoPilotFilters, AutoPilotResponseData, AutopilotGear } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getAutopilot(filters?: AutoPilotFilters): Promise<AutoPilotResponseData[]> {
  const response = await api.get(ENDPOINTS.AUTOPILOT, {
    params: filters,
  });
  
  return response.data;
}

export async function setAutopilotStatus(id: string, status: AutoPilotStatus): Promise<AutoPilotResponseData> {
  const response = await api.patch(`${ENDPOINTS.AUTOPILOT}${id}/`, {
      autopilot_status: status,
  });
  
  return response.data;
}

/**
 * Update the autopilot gear
 */
export async function setAutopilotGear(id: string, gearId: number): Promise<AutoPilotResponseData> {
  const response = await api.patch(`${ENDPOINTS.AUTOPILOT}${id}/`, {
    current_gear: gearId,
  });
  
  return response.data;
}

/**
 * Fetch autopilot gears
 */
export async function getAutopilotGears(): Promise<AutopilotGear[]> {
  const response = await api.get(ENDPOINTS.AUTOPILOT_GEARS);
  
  return response.data.data;
}